/*
pagesegmode values are:
0 = Orientation and script detection (OSD) only.
1 = Automatic page segmentation with OSD.
2 = Automatic page segmentation, but no OSD, or OCR
3 = Fully automatic page segmentation, but no OSD. (Default)
4 = Assume a single column of text of variable sizes.
5 = Assume a single uniform block of vertically aligned text.
6 = Assume a single uniform block of text.
7 = Treat the image as a single text line.
8 = Treat the image as a single word.
9 = Treat the image as a single word in a circle.
10 = Treat the image as a single character.
*/
//https://www.ttmind.com/techpost/how-to-extract-text-from-image-using-angularocr-with-tessera

import { DataSource } from '@angular/cdk/collections';
import { AdminGuardService } from './../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck,ViewEncapsulation } from '@angular/core';
import {MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { AuthService } from '../../servicios/auth.service';
import { UserGuardService } from '../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../servicios/guards/multi-user.service';
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { read } from 'cfb/types';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';

//ngx-webcam 1
import {Subject} from 'rxjs';
import {Observable} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import { environment } from "environments/environment";
declare var $: any;

//servicio global
import { GLOBALService } from "../../servicios/functions/GLOBAL.service";
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { createWorker } from 'tesseract.js';
//import { NgQrScannerModule } from 'angular2-qrscanner';
//qr 1
import {QrScannerComponent} from 'angular2-qrscanner';
//spellcheck1
import { SpellCheckerService } from 'ngx-spellchecker';

declare var Tesseract;

@Component({
  selector: 'app-cg',
  templateUrl: './cg.component.html',
  styleUrls: ['./cg.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CGComponent implements OnInit, DoCheck {
  //spellcheck2
  fileURL = "https://raw.githubusercontent.com/JacobSamro/ngx-spellchecker/master/dict/normalized_en-US.dic";

  ocrResult = 'Pulse SCAN para reconocer..';
  Result = 'Recognizing...';
  res = [];
  loading;
  foti;
  files;
  fotob64;
  fotodetalle;
  //ngx-webcam 2
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
     //width: {ideal: 576},
     //height: {ideal: 1024}
  };
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();

  name: string;
  position: number;
  weight: number;
  symbol: string;
  //progress=0;
  fechaok;
  importeok;
  objResult;
  
  //qr2
  @ViewChild(QrScannerComponent) qrScannerComponent: QrScannerComponent ;
  getQr = 'noget';
  
  public uploader: FileUploader = new FileUploader({
    url: `${environment.backendUrl}/api/importador/importar`,
    itemAlias: 'foto',
    headers: [{ name: 'Access-Control-Allow-Origin', value: '*'}]
  });

  constructor(
    public snackBar: MatSnackBar,
    private datePipe: DatePipe,
    //spellcheck3
    //private spellCheckerService: SpellCheckerService,
    private httpClient: HttpClient
    ) { }

  ngDoCheck(){
    //console.log(this.ocrResult);
    //console.log(this.getQr);
    
    //const videoDevices: MediaDeviceInfo[] = [];
    //console.log(videoDevices.length + " camaras..");
    //console.log("docheckcuentacamaras");
    //console.log(JSON.stringify(this.objdevices));
  }
/*
  spellChecker(){
    this.httpClient.get(this.fileURL, { responseType: 'text' }).subscribe((res: any) => {
      let dictionary = this.spellCheckerService.getDictionary(res)
      console.log(dictionary.spellCheck("test"))
    });
  }
*/
  scan(){
    document.getElementById("botonScan").click();
  }

  borraDatos(){
    this.getQr='noget';
    this.ocrResult='recognizing text';
    this.importeok=null;
    this.totalok=null;
    this.fechaok=null;
    this.loading=false;
  }
  
  camara;
  errorqr;
  getQR(){
     //qr 3
     this.qrScannerComponent.getMediaDevices().then(devices => {
      console.log(devices);
      const videoDevices: MediaDeviceInfo[] = [];
      for (const device of devices) {
          if (device.kind.toString() === 'videoinput') {
              videoDevices.push(device);
          }
      }
      if (videoDevices.length > 0){
          let choosenDev;
          for (const dev of videoDevices){
              if (dev.label.includes('back')){
                  choosenDev = dev;
                  console.log("CHOOSENDEV: " + choosenDev);
                  break;
              }
          }
          if (choosenDev) {
              this.qrScannerComponent.chooseCamera.next(choosenDev);
          } else {
              this.qrScannerComponent.chooseCamera.next(videoDevices[0]);
          }
          this.camara = videoDevices[0].label;
          console.log(videoDevices[0]);
          console.log(this.camara); 
        }
    });

    this.qrScannerComponent.capturedQr.subscribe(result => {
      console.log(result);
      this.getQr = result;
      document.getElementById("cerrarModalQR").click();
    }, error => {
      console.log(error);
      document.getElementById("cerrarModalQR").click();
      this.errorqr = error;
    });

  }

  camarasdispo;
  changeCam(){
    //qr 3
    this.qrScannerComponent.getMediaDevices().then(devices => {
      console.log(devices);
      const videoDevices: MediaDeviceInfo[] = [];
      for (const device of devices) {
          if (device.kind.toString() === 'videoinput') {
              videoDevices.push(device);
          }
      }
      if (videoDevices.length > 0){
          let choosenDev;
          for (const dev of videoDevices){
              if (dev.label.includes('back')){
                  choosenDev = dev;
                  console.log("CHOOSENDEV: " + choosenDev);
                  break;
              }
          }
          if (choosenDev) {
              this.qrScannerComponent.chooseCamera.next(choosenDev);
          }
        }
      });

  }

  mostrarTexto(){
    $("#ModalWarning").show();
    /*
    $("#ModalWarning").on('hidden.bs.modal', function(){
      //alert("Hello World!");
    });
    */
  }
  //to async mode
  reconocer(){
    this.loading=true;
    Tesseract.recognize(this.fotodetalle,'spa','SPARSE_TEXT').progress((progress) => {
      //console.log(progress, "$$$$");
      if (progress.status === "recognizing text"){
        $('#progress').text(Math.round(progress.progress * 100) + '%');
        this.ocrResult = progress.status;
      }
    }).then((result) =>{
        //$('#result').text(result.text);
        console.log(result);
        console.log(result.blocks[0]["words"][0]["text"]);
        this.ocrResult = result.text.toString();
        this.getDatos();
        this.loading = false;
    });

  }
  posi;
  getPos(){
    var loro = 
      `
      LEONARDI DIEGO ALEJANDRO c010: 20-20320402-1 INGRESOS 000003: 1147875'06 > Av. ensues 2706 
      - C.A.B.A. IVA 00500030000 INSCRIPTO 0 0003001000 FINAL. _, P.V.:UOU3 00:01 N0.T:00002972 \ 
      x ‘ 13/01/2020 07:20 ‘\ - x . \ \ ‘ ‘ 6X 550,00 0, \ ” GOLOSINAS 3.300, 00 3% .
       :17'6'17313‘"”mm—733007000‘01“}, 9 _ . EFEC'I‘IVO 3.30000 “1.0;.” 0 . CANT. ITEMS : 1 ”[2,! Jr .\
         $ELEEé~aﬁ§R"'g_ $030? ‘30 ‘céﬁgoni‘b‘gﬁ ; ‘ ’ *‘ .. ﬁst-$052939; ,;v,i:/r ' 
         3 \‘~\\ -Wn. _, ”80' ‘ , ‘ ‘ m? ; «My U » 0 , \ .021” ,' \ _ . _ y . a:'~‘r=.§F~.::,. " '
          _‘ , ‘13: ‘7‘; . '
      `;
      
    //this.posi = loro.search("fecha"); // devuelve 76
    this.posi = loro.indexOf("fecha");
    console.log(this.posi);
    console.log("FECHA: " + loro.slice(this.posi, this.posi + 16));
    //console.log("FECHA: " + loro.slice(this.posi, this.posi + 16));
  }
  totalok;
  getDatos(){
    var str = this.ocrResult.toString();
      /*
      `
      LEONARDI DIEGO ALEJANDRO c010: 20-20320402-1 INGRESOS 000003: 1147875'06 > Av. ensues 2706 
      - C.A.B.A. IVA 00500030000 INSCRIPTO 0 0003001000 FINAL. _, P.V.:UOU3 00:01 N0.T:00002972 \ 
      x ‘ 13/01/2020 07:20 ‘\ - x . \ \ ‘ ‘ 6X 550,00 0, \ ” GOLOSINAS 3.300, 00 3% .
       :17'6'17313‘"”mm—733007000‘01“}, 9 _ . EFEC'I‘IVO 3.30000 “1.0;.” 0 . CANT. ITEMS : 1 ”[2,! Jr .\
         $ELEEé~aﬁ§R"'g_ $030? ‘30 ‘céﬁgoni‘b‘gﬁ ; ‘ ’ *‘ .. ﬁst-$052939; ,;v,i:/r ' 
         3 \‘~\\ -Wn. _, ”80' ‘ , ‘ ‘ m? ; «My U » 0 , \ .021” ,' \ _ . _ y . a:'~‘r=.§F~.::,. " '
          _‘ , ‘13: ‘7‘; . '
      `;
      */
      var fecha = str.match(/(\d{2}([.\-/])\d{1,2}([.\-/])\d{4})|(\d{4}([.\-/])\d{1,2}([.\-/])\d{2})/g);
      console.log("date recognized= " + fecha);
      // 1. busco por string la similitud y obtengo la posicion.
      var postot = str.indexOf("EFEC");
      var postotal = str.indexOf("TOTAL");
      // 2. extraigo los proximos 20 caracteres desde la posicion indicada
      var totstr = str.slice(postot, postot + 20);
      var totalstr = str.slice(postotal, postotal + 25);
      // 3. match regex para extraer lo que necesito..
      var tot = totstr.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/);
      var totale = totalstr.match(/\d+\.\d{1,2}/);
      //loro.match(/(TOT|EFEC|tot|efec)/);
      console.log("efect utilizado: " + totstr);
      console.log("total supuesto: " + totalstr);
      this.fechaok = fecha;

      try {
        this.importeok = parseFloat(tot.toString());
        this.importeok = this.importeok * 1000;
        console.log("efec parseado: $" + this.importeok);
      } catch (error) {
        console.log("ERROR AL PARSEAR efec: '"+error+"'");
      }
      
      try {
        this.totalok = parseFloat(totale.toString());
        console.log("total parseado: $" + this.totalok);  
      } catch (error) {
        console.log("ERROR AL PARSEAR total: '"+error+"'");
      }
      
  }

  borraBasura(){
    var str = 
      `
      LEONARDI DIEGO ALEJANDRO c010: 20-20320402-1 INGRESOS 000003: 1147875'06 > Av. ensues 2706 
      - C.A.B.A. IVA 00500030000 INSCRIPTO 0 0003001000 FINAL. _, P.V.:UOU3 00:01 N0.T:00002972 \ 
      x ‘ 13/01/2020 07:20 ‘\ - x . \ \ ‘ ‘ 6X 550,00 0, \ ” GOLOSINAS 3.300, 00 3% .
       :17'6'17313‘"”mm—733007000‘01“}, 9 _ . EFEC'I‘IVO 3.30000 TOTAL 3.30000 “1.0;.” 0 . CANT. ITEMS : 1 ”[2,! Jr .\
         3 \‘~\\ -Wn. _, ”80' ‘ , ‘ ‘ m? ; «My U » 0 , \ .021” ,' \ _ . _ y . a:'~‘r=.§F~.::,. " '
          _‘ , ‘13: ‘7‘; . '
      `;
      console.log(str);
      console.log(str.length + " chars");
      //var sinbasura = str.replace(/'I‘/g, "T");
      //console.log(sinbasura);
      //console.log(sinbasura.length + " chars");
      var fecha = str.match(/(\d{1,4}([.\])\d{1,2}([.\-/])\d{1,4})/g);
      console.log("date recognized= " + fecha);
      var postot = str.indexOf("EFEC");
      var postotal = str.indexOf("TOTAL");
      var totstr = str.slice(postot, postot + 20);
      var totalstr = str.slice(postotal, postotal + 20);
      var tot = totstr.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/);
      var totale = totalstr.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/);
      //loro.match(/(TOT|EFEC|tot|efec)/);
      console.log("string utilizado: " + totstr);
      console.log("total supuesto: " + tot);
      console.log("total supuesto2: " + totale);
      this.fechaok = fecha;
      this.importeok = parseFloat(tot.toString());
      this.importeok = this.importeok * 1000;
  }

  recognizeTo(){
    this.ocrResult = 'Reconociendo..';
    this.loading=true;
    this.doOCR();
  }

  async doOCR() {
    const worker = createWorker({
      logger: m => console.log(m),
    });
    await worker.load();
    await worker.loadLanguage('spa');
    await worker.initialize('spa');
    let respuesta = await worker.recognize(this.fotodetalle);
    this.ocrResult = respuesta.data.text.toString();
    console.log(this.ocrResult);
    await worker.terminate();
    this.loading=false;
  }  

  userlog;
  objdevices = [];
  ngOnInit() {
    
    this.userlog = localStorage.getItem("userId");
     ////ngx-webcam 2
     WebcamUtil.getAvailableVideoInputs()
     .then((mediaDevices: MediaDeviceInfo[]) => {
       this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
     });

     
     //reconocer camaras
     const videoDevices: MediaDeviceInfo[] = [];
     this.qrScannerComponent.getMediaDevices().then(devices => {
       //console.log(devices);
       const videoDevices: MediaDeviceInfo[] = [];
       for (const device of devices) {
           if (device.kind.toString() === 'videoinput') {
               videoDevices.push(device);
               this.objdevices.push(device);
               console.log(device);
               console.log("paso x el for device");
           }
       }
      });
      console.log("dispo encontrados..");
      console.log(JSON.stringify(this.objdevices));
   
      //cambiar a camara trasera..
      this.changeCam();
  }

  apagaCamara(){
  
  }

  subirImagenDesdePc(){
    this.fotodetalle=this.fotob64;
    console.log("resize imagen subida deshabilitado");
    this.fotodetalle=this.fotodetalle;
  }

  getFiles(event) {
    this.files = event.target.files;
    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(this.files[0]); 
  }

  //obtengo base64 de imagen subida
  _handleReaderLoaded(readerEvt) {
    var b64String = readerEvt.target.result;
    this.fotob64=b64String
    //console.log(this.fotob64);
  }

  
  snackCamara(){
    // snackbar si encuentra al usuario
    this.snackBar.open('IMAGEN LISTA!!!', 'Cerrar', {duration: 3000});
    //document.getElementById("botonScan").click();
  }


  test(){
    this.loading=true;
    Tesseract.recognize(`${this.fotodetalle}`).then(function(result){         
      //alert(result.text);      
      console.log(result.text);    
      console.log(result);
      localStorage.setItem("ocr",result.text);
    });    
    this.loading=false;
    this.Result = localStorage.getItem("ocr");
    console.log(this.Result);
    
  }  

  
  //ngx-webcam 3
  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean|string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
    //console.log(this.webcamImage.imageAsDataUrl);
    //hago el resize de la fotodetalle antes de guardarlo
    console.log("resize imagen desde webcam..");
    this.fotodetalle=this.webcamImage.imageAsDataUrl;
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  limpiacam(){
    this.showWebcam = false;
    this.fotodetalle=[];
    this.fotodetalle=null;
    this.webcamImage=null;
  }

  // fin ngx-webcam 



  prendeCamara(){
    //prende ngx-webcam 4
    this.showWebcam = true;  
  }
  sumi;
  quitarImagen(){
    this.fotodetalle=null;
    this.limpiacam();
    this.sumi = 0;
  }
}
